import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createCustomer } from '@/apis/customers'
import { CUSTOMER_TYPES } from '@/constants/customer'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateCustomerRequest } from '@/types/apis/customers/CreateCustomerRequest'
import { CreateCustomerResponse } from '@/types/apis/customers/CreateCustomerResponse'

export const useCreateCustomer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateCustomerResponse>()

  const create = useCallback(
    async (request: CreateCustomerRequest) => {
      try {
        setLoading(true)
        const res = await createCustomer({ ...request, type: CUSTOMER_TYPES[0].id })
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        navigate(routes.laundry.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createCustomer: create,
    response,
  }
}
